import { JSX } from "react";
import { Control, useFieldArray } from "react-hook-form";
import FormInputComponent from "@via/components/inputs/form-input-component.tsx";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";

interface McpServerHeadersInputProps {
  control: Control<any>;
  name: string;
}

const McpServerHeadersInput = ({
  control,
  name,
}: McpServerHeadersInputProps): JSX.Element => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  return (
    <div>
      <label className="mb-2 flex items-center text-sm font-medium leading-6 text-gray-900">
        Headers
      </label>
      <p className="mb-2 text-sm text-gray-500">
        Add custom HTTP headers as key-value pairs
      </p>
      <div className="space-y-2">
        {fields.map((field, index) => (
          <div key={field.id} className="flex gap-2 items-start">
            <div className="flex-1">
              <FormInputComponent
                control={control}
                name={`${name}.${index}.key`}
                placeholder="Header name (e.g., Authorization)"
              />
            </div>
            <div className="flex-1">
              <FormInputComponent
                control={control}
                name={`${name}.${index}.value`}
                placeholder="Header value"
              />
            </div>
            <button
              type="button"
              onClick={() => remove(index)}
              className="mt-2 p-2 text-gray-400 hover:text-red-500 transition-colors"
              title="Remove header">
              <TrashIcon className="h-5 w-5" />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={() => append({ key: "", value: "" })}
        className="mt-2 inline-flex items-center gap-1 text-sm text-indigo-600 hover:text-indigo-500">
        <PlusIcon className="h-4 w-4" />
        Add Header
      </button>
    </div>
  );
};

export default McpServerHeadersInput;
